import { useTranslation } from '@mc/i18n'

export default function Layout({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation('@mc/next')
  return (
    <div className='container mc-mt-10'>
      <h1 className='mc-text-h1 mc-mb-8'>{t('sitemap.title')}</h1>
      {children}
    </div>
  )
}
